export default "__VITE_ASSET__CjDgymUt__"